import moment from 'moment'

export function addActiveField (object, startDate, endDate) {
  const currentDate = moment().unix()
  const checkEndDate = endDate !== null ? endDate : moment().add(2112, 'y').unix()
  object['active'] = startDate <= currentDate && checkEndDate > currentDate
  object['future'] = currentDate < startDate
}
